/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareTriangleCircleTriangleFill: {
  name: 'square-triangle-circle-triangle-fill';
  data: string;
} = {
  name: 'square-triangle-circle-triangle-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.894 3.553a1 1 0 0 0-1.788 0l-3 6A1 1 0 0 0 14 11h6a1 1 0 0 0 .894-1.447l-3-6ZM5 13a1 1 0 0 0-.949.684l-1 3a1 1 0 0 0 0 .632l1 3A1 1 0 0 0 5 21h4a1 1 0 0 0 .949-.684l1-3a1 1 0 0 0 0-.632l-1-3A1 1 0 0 0 9 13H5ZM3 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm14 9a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" fill="currentColor"/></svg>`,
};
